import {StateVoucher} from './app.state-voucher';
import {VoucherActionType} from './app.actions-voucher';
const initialState: StateVoucher = {
    nbVoucherAdded: 0,
    //response: [],
};

export function reducerVoucher(state: StateVoucher = initialState, action) {
    switch (action.type) {
        case VoucherActionType.AddNew:
            return {
                ...state, response: action.payload, nbVoucherAdded: state.nbVoucherAdded + 1
            };
        default:
            return state;
    }
}